import Checkit from 'checkit';
Checkit.i18n['ja'] = Checkit.i18n['en'];

export default function clientMiddleware(client, api) {
  return ({ dispatch, getState }) => {
    return (next) => (action) => {
      const { promise, types, type, ...rest } = action;
      // FIXME: fix this
      // Checkit.language = getState().auth.getIn(['user', 'locale', 'short']).substr(0, 2);

      if (!promise) {
        if (typeof action === 'function') {
          action = action({ api, client, dispatch, getState, Checkit });

          // let type = action.type;
        }
        return next(action);
      }



      // debugger;

      const [REQUEST, SUCCESS, FAILURE] = types;
      next({ ...rest, type: REQUEST });

      // debugger;


      // return promise(client).then(
      // return promise.then(function(func) {
      //   return func(client);
      // }).then(
      // // return promise.then(
      //   (result) => next({...rest, result, type: SUCCESS}),
      //   (error) => {
      //     return next({...rest, error, type: FAILURE});
      //     // throw(error);
      //   }
      // );

      return promise.then(function (func) {
        return func({ api, client, dispatch, getState, Checkit });
      }).then(
        (result) => next({ ...rest, result, type: SUCCESS })
      ).catch(
        (error) => {
          let x = next({ ...rest, error, type: FAILURE });
          // if (__CLIENT__) throw error;
          if (error.hasOwnProperty('stack')) console.error(error.stack);
          return x;
          // return {cow: 'test'};
          // throw(error);
        }
      );

    };
  };
}

// export function promiseMiddleware() {
//   return (next) => (action) => {
//     const { promise, types, ...rest } = action;
//     if (!promise) {
//       return next(action);
//     }

//     const [REQUEST, SUCCESS, FAILURE] = types;
//     next({ ...rest, type: REQUEST });
//     return promise.then(
//       (result) => next({ ...rest, result, type: SUCCESS }),
//       (error) => next({ ...rest, error, type: FAILURE })
//     );
//   };
// }



// WEBPACK FOOTER //
// ./src/redux/clientMiddleware.js